import { SVGProps } from 'react';

const SvgAddGroup = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 14" {...props}>
        <path d="M12.95 5.786a2.893 2.893 0 1 0 0-5.787 2.893 2.893 0 0 0 0 5.787Zm0-3.857a.964.964 0 1 1 0 1.928.964.964 0 0 1 0-1.928Zm3.963 3.722a4.822 4.822 0 0 0 0-5.516c.277-.09.567-.135.858-.135a2.893 2.893 0 0 1 0 5.786c-.291 0-.58-.046-.858-.135ZM12.95 7.714c-5.786 0-5.786 3.857-5.786 3.857V13.5h11.572v-1.929s0-3.857-5.786-3.857Zm-3.857 3.857c0-.28.308-1.928 3.857-1.928 3.375 0 3.8 1.504 3.857 1.928m6.75 0V13.5h-2.893v-1.929a5.401 5.401 0 0 0-1.736-3.799c4.629.473 4.629 3.8 4.629 3.8ZM8.128 6.75H5.235v2.893H3.307V6.75H.414V4.821h2.893V1.93h1.928V4.82h2.893V6.75Z" />
    </svg>
);
export default SvgAddGroup;
